import { LinkSize } from '@vizit/atoms';
import { VizitLogo } from '@vizit/icons';
import { Heading, HeadingVariant, RouterLink } from '@vizit/molecules';
import { SsoErrorAlert, SsoLoginError } from '../sso-error-alert';

interface SsoErrorProps {
  /**
   * The SSO error type to display.
   *
   * @optional
   * @type {SsoLoginError | string}
   */
  error?: SsoLoginError | string;
}

const SSO_LOGIN_ERRORS = new Set<string>(Object.values(SsoLoginError));

function normalizeError(error?: SsoLoginError | string): SsoLoginError {
  if (error && SSO_LOGIN_ERRORS.has(error)) return error as SsoLoginError;
  return SsoLoginError.GenericError;
}

function SsoError(props: SsoErrorProps) {
  const { error } = props;
  const normalizedError = normalizeError(error);

  return (
    <div className="flex-grow flex flex-col justify-center items-center gap-16" data-testid="sso-error-page">
      <div className="flex flex-col items-center gap-16">
        <VizitLogo aria-label="Vizit Logo" />
        <Heading variant={HeadingVariant.H5}>Sign-in error</Heading>
      </div>
      <div className="flex flex-col justify-center items-center gap-8">
        <SsoErrorAlert error={normalizedError} />
        <RouterLink size={LinkSize.Sm} to="/sso" data-testid="sso-error-back-link">
          Back to login
        </RouterLink>
      </div>
    </div>
  );
}

export { SsoError };
export type { SsoErrorProps };
